import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch ,useSelector } from 'react-redux'
import { showModaStatus ,ModalStatusState ,closeModalStatus } from '../redux/slices/modalStatusSlice'

export const useModalStatus = () => {
    const dispatch = useDispatch()
    const modalStatusState =  useSelector(state => state.modalStatus)

    const WAITING :ModalStatusState ={
        isShowModalStatus: true,
        title: "Waiting for confirmation",
        msg: "",
        contentType: "loading",
        icon: "",
    }

    const SUCCESS :ModalStatusState ={
        isShowModalStatus: true,
        title: "Transaction submited",
        msg: "",
        contentType: "success",
        icon: "",
    }

    const FAIL :ModalStatusState ={
        isShowModalStatus: true,
        title: "Transfer failed please try again",
        msg: "",
        contentType: "fail",
        icon: "",
    }

    const  STATUS : { [key: string]: ModalStatusState } ={
        WAITING,
        SUCCESS,
        FAIL
    }

    const STATUS_TYPE = {
        "WAITING" :  "WAITING"  ,
        "SUCCESS" :  "SUCCESS" ,
        "FAIL" :  "FAIL"
    }


    const  setShowModal = ( param:ModalStatusState   ):void => {
        dispatch(showModaStatus(param))
    }  

    const  setShowModalStaus = (  statusType:string ):void => {
        dispatch(showModaStatus(STATUS [statusType]))
    }   

    const setCloseModalStatus = () => {
        dispatch(closeModalStatus())
    }

    const setModalForHandleError = (error:any) => {
        if (error.code === 4001 || error.message == "User rejected the transaction") {
            setCloseModalStatus()
        }else{
            setShowModalStaus(STATUS_TYPE.FAIL)
        }

    }
    
  return {
    setShowModal,
    setShowModalStaus,
    setCloseModalStatus,
    modalStatusState,
    STATUS_TYPE,
    setModalForHandleError
  }
}

